<template>
    <div class="wrap">
        <div class="header">
            <div class="header-left" @click="goBack"><img v-if="!shareType" src="@/assets/public/icon_back.png" alt=""/></div>
            <div class="header-main">{{ cGoodsDto.goodsName }}</div>
            <div class="header-right">
                <img v-if="!shareType" src="@/assets/public/icon_fx01.png" alt="" @click="openSharePanel"/>
                <img v-if="!shareType" src="@/assets/public/icon_customerservice.png" alt="" @click="pushCusService"/>
            </div>
        </div>

        <share-ad :detail="shareInfo">
          <template v-if="goodsCode && codeList[goodsCode] && cGoodsDto.goodsName">
            <div style="position: relative" >
              <img width="100%"  @click="play" :src="require(`@/assets/vipGoods/${goodsCode}/${codeList[goodsCode].top}`)" alt="">
              <div class="play">
                <div class="play-icon" @click="play" v-show="playVisible === 1"><img src="@/assets/vipGoods/icon_bfan01.png" alt=""></div>
                <div class="video" v-show="playVisible === 2" id="player"></div>
              </div>
            </div>
            <div class="item-menu">
              <div :class="['item-menu-content',v.goodsCode === cGoodsDto.goodsCode && 'active']" v-for="(v,i) in switchGoods" :key="i" @click="goodsSwitch(v)" v-show="switchGoods.length > 1">
                <div class="title">{{ v.goodsName }}</div>
                <div class="price">¥<b>{{ v.payConPrice }}</b>{{ v.effectiveDays|unit }}</div>
                <div class="desc">{{ v.goodsDesc }}</div>
                <div class="right-top-icon" v-if="v.warnTips">{{ v.warnTips }}</div>
              </div>
            </div>
            <template v-for="(v,i) in codeList[goodsCode].list">
              <!--其他组件判断-->
              <component :key="v + key" :is="v" v-if="v.indexOf('c-') > -1" :cityCode="cityCode" :goodsCode="goodsCode" :initExamPlaceBatchId="examPlaceBatchId" :ref="v" @submit="(s)=>{submit(s)}"/>
              <!-- 剩下的图片 -->
              <img :key="i" class="bg" :src="require(`@/assets/vipGoods/${v}`)" v-else-if="v.indexOf('ensure') === -1" alt=""/>
              <!--过考保障判断 ensureFlag:单科有过考保障 ensureSubject套餐有过考保障-->
              <template v-else-if="pageDto.noneOpendSonSelectedDto.ensureFlag || (pageDto.noneOpendSonSelectedDto.ensureSubject && pageDto.noneOpendSonSelectedDto.containGoodsCode)">
                <!-- ensureSubject 1:科目一 4:科目四 5:科目一+科目四 -->
                <img v-if="pageDto.noneOpendSonSelectedDto.ensureSubject && pageDto.noneOpendSonSelectedDto.containGoodsCode" :key="'gkzb' + i" class="bg" :src="require(`@/assets/vipGoods/ensure-${pageDto.noneOpendSonSelectedDto.ensureSubject}.png`)" />
                <!-- 单科的状态下 并且显示过考保障 -->
                <img v-else-if="!pageDto.noneOpendSonSelectedDto.containGoodsCode && pageDto.noneOpendSonSelectedDto.ensureFlag" :key="i" class="bg" :src="require(`@/assets/vipGoods/${v}`)" />
              </template>
            </template>

            <c-essence :essenceList="pageDto.noneOpendSonSelectedDto.sonMicrocourseDtoList"/>

            <div class="question">
              <img class="title" src="@/assets/vipGoods/cjwt.png" alt="">
              <template v-for="(v,i) in codeList[goodsCode].question">
                <template v-if="isShowEnsure(v)">
                    <div :key="i + 'label'" class="question-title" v-html="v.label"> </div>
                    <div :key="i + 'value'" class="question-content" v-html="v.value"></div>
                </template>
              </template>
            </div>

          </template>
        </share-ad>

        <div class="mamber-tips">
            <div class="mamber-info">开通前请阅读<span class="tutorial" @click="handleOpenMember">《会员协议》</span></div>
            <div v-show="!loading && IOS" class="tutorial" @click="goTutorial()">iPhone支付教程</div>
        </div>

        <div class="footer" v-show="!loading">
          <div class="footer-item-menu" v-if="switchGoods.length > 1">
            <div :class="['footer-item-menu-content',v.goodsCode === cGoodsDto.goodsCode && 'active']" v-for="(v,i) in switchGoods" :key="i" @click="goodsSwitch(v)" >
              <div class="title">{{ v.goodsName }}</div>
              <div class="price">¥<b>{{ v.payConPrice }}</b>{{ v.effectiveDays | unit }}</div>
              <div class="right-top-icon" v-if="v.warnTips">{{ v.warnTips }}</div>
            </div>
          </div>

          <div :class="['submit', disabled && 'disabled']" @click="submit()">
            <div class="price">
              <span class="t1">￥{{ cGoodsDto.payConPrice }}</span><span class="unit">{{ cGoodsDto.effectiveDays|unit }}</span><span class="t2">原价¥{{ cGoodsDto.payOrigPrice }}</span>
            </div>
          </div>
        </div>
        <div class="tips-effect-wrap" v-if="warnTipsShow">
            <div class="tips-effect" v-if="switchGoods[1]">
                <div class="right-price" v-if="switchGoods[1].warnTips">{{switchGoods[1].warnTips}}</div>
                <div class="content">{{switchGoods[1].goodsName}}</div>
            </div>
        </div>

        <!--消息弹出框-->
        <ctl-dialog v-model="messageDialog" :loading="dialogLoading"/>
    </div>
</template>

<script>
import codeList from './code.json'
import { Popup, Toast } from 'vant'
import cExamRoom from './components/cExamRoom'
import cEssence from './components/cEssence'
import cLight from './components/cLight'
import cIntroduce from './components/cIntroduce'
import ctlDialog from '@/components/dialog/index.vue'

export default {
    name: 'vipGoods',
    components: {
        ctlDialog,
        [Popup.name]: Popup,
        cEssence,
        cLight,
        cIntroduce,
        cExamRoom
    },
    data () {
        return {
            // h5标记
            H5: false,
            playVisible: false,
            warnTipsShow: true,
            appType: '',
            version: '',
            shareType: '',
            goodsCode: '',
            subject: '',
            key: 0,
            carType: '',
            autoOpen: '',
            cityCode: '',
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            disabled: false,
            examRoom: false,
            loading: false,
            dialogLoading: false,
            codeList: codeList,
            cGoodsDto: {},
            userInfo: {},
            shareInfo: {},
            player: {},
            examPlaceBatchId: '',
            pageDto: {
                noneOpendSonSelectedDto: {
                    sonMicrocourseDtoList: []
                }
            },
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            switchGoods: []
        }
    },
    methods: {
        // 是否显示过考保障文案
        isShowEnsure ({ id }) {
            let showStatus = true
            // 有id 表示过考保障
            if (id) {
                // 区分当前商品是单科还是全科
                if (this.pageDto.noneOpendSonSelectedDto.containGoodsCode && this.pageDto.noneOpendSonSelectedDto.containGoodsCode.length) { // 存在 并且长度不为0 表示套餐
                    // ensureSubject字段不为0 表示已经开启过考保障
                    showStatus = !!this.pageDto.noneOpendSonSelectedDto.ensureSubject
                } else { // 否则单科逻辑
                    showStatus = this.pageDto.noneOpendSonSelectedDto.ensureFlag
                }
            }
            return showStatus
        },
        play () {
            if (this.playVisible) {
                this.playVisible = 2
                this.player.play()
            }
        },
        // 获取分享配置信息
        getSetting () {
            this.$api.getAdSetting({ code: this.codeList[this.goodsCode].shareCode }).then(res => {
                if (res.status && res.result) {
                    this.shareInfo = res.result
                }
            })
        },
        getPlayAuth () {
            this.playVisible = 0
            if (!this.cGoodsDto.introduceVid) {
                return
            }
            this.$api.getAliPlayAuth({ vid: this.cGoodsDto.introduceVid }).then(res => {
                if (res.status) {
                    setTimeout(() => {
                        this.player.dispose && this.player.dispose()
                        this.player = {}
                        this.playVisible = 1
                        this.player = new Aliplayer({
                            'id': 'player',
                            'vid': this.cGoodsDto.introduceVid,
                            'playauth': res.result,
                            'qualitySort': 'asc',
                            'format': 'mp4',
                            'mediaType': 'video',
                            'width': '94.66667vw',
                            'height': '53.33333vw',
                            'autoplay': false,
                            'isLive': false,
                            'rePlay': false,
                            'playsinline': true,
                            'preload': true,
                            'controlBarVisibility': 'hover',
                            'useH5Prism': true,
                            'skinLayout': [
                                {
                                    'name': 'controlBar',
                                    'align': 'blabs',
                                    'x': 0,
                                    'y': 0,
                                    'children': [
                                        {
                                            'name': 'progress',
                                            'align': 'blabs',
                                            'x': 0,
                                            'y': 44
                                        },
                                        {
                                            'name': 'playButton',
                                            'align': 'tl',
                                            'x': 15,
                                            'y': 12
                                        },
                                        {
                                            'name': 'timeDisplay',
                                            'align': 'tl',
                                            'x': 10,
                                            'y': 7
                                        },
                                        {
                                            'name': 'fullScreenButton',
                                            'align': 'tr',
                                            'x': 10,
                                            'y': 12
                                        },
                                        {
                                            'name': 'volume',
                                            'align': 'tr',
                                            'x': 5,
                                            'y': 10
                                        }
                                    ]
                                }
                            ]
                        }, function (player) {
                            console.log('The player is created')
                        }
                        )
                    }, 200)
                }
            })
        },
        // 立即开通
        submit (v) {
            if (this.H5) {
                this.linkApp()
                return
            }

            if (this.disabled) {
                return
            }

            if (this.appType !== 1 && this.version < '3.0.0' && !['100', '101', '105', '104', '107', '200'].includes(this.goodsCode)) {
                Toast('请升级App！')
                return
            }

            // 考场组件选择判断
            if (this.$refs['c-examRoom'] && this.$refs['c-examRoom'][0] && !v) {
                if (this.$refs['c-examRoom'][0].examVisible) {
                    this.$refs['c-examRoom'][0].examRoomVisible = true
                } else {
                    Toast('当前选中的城市没有考场视频！')
                }
                return
            }
            this.examPlaceBatchId = v

            // 除了IOS设备都需要登陆
            if (!this.IOS && !this.userInfo.userId) {
                this.$jsBridge.hasNativeMethod('loginUserV2') ? this.$jsBridge.callBackHandler('loginUserV2') : this.$jsBridge.callBackHandler('loginUser')
                return
            }

            // 请求数据
            let postData = {
                currentUserId: this.userInfo.currentUserId,
                cityCode: this.cityCode,
                goodsCode: this.goodsCode,
                examPlaceBatchId: this.examPlaceBatchId
            }

            Toast.loading({ duration: 0, overlay: true, message: '加载中...' })
            this.$api.vipGoodsPay(postData).then(res => {
                Toast.clear()
                // 正常支付流程
                if (res.code === '200' && res.status) {
                    // 判断是否IOS && 苹果支付
                    if (this.IOS) {
                        // 唤起支付
                        this.$jsBridge.callBackHandler('applyPay', {
                            orderId: res.result,
                            productId: this.cGoodsDto.productId,
                            goodsCode: this.goodsCode
                        })
                        return
                    }

                    this.$router.push({
                        name: 'pay',
                        query: {
                            isOpen: this.autoOpen,
                            payId: res.result,
                            money: this.cGoodsDto.payConPrice,
                            goodsCode: this.goodsCode,
                            headShow: '1'
                        }
                    })
                }

                // 错误状态码处理
                if (res.code === '701') {
                    // 兼容自动开通
                    if (this.autoOpen) {
                        this.$jsBridge.callBackHandler('openFail', { msg: res.message })
                    }
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去支付',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                            this.goDetail({
                                id: res.result.split('-')[0],
                                orderType: Number(res.result.split('-')[1])
                            })
                        },
                        title: '',
                        content: '您有VIP商品订单未支付'
                    }
                }
                if (!['200', '701'].includes(res.code)) {
                    Toast(res.message)
                }
            })
        },
        // 跳转详情
        goDetail (v) {
            if (v.orderType === 2) {
                this.$router.push({
                    name: 'goodsOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1', sourceType: this.appType === 100 ? '2' : '1' }
                })
            } else if (v.orderType === 4) {
                this.$router.push({
                    name: 'teachVideoOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 6) {
                this.$router.push({
                    name: 'peijiaOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 7) {
                this.$router.push({
                    name: 'ensureOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 8) {
                this.$router.push({
                    name: 'vipPackageOderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 9) { // 跳转到灯光仿真的订单详情页
                this.$router.push({
                    name: 'goodsLightOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 10) { // 跳转到微课的订单详情页
                this.$router.push({
                    name: 'microCourseOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 11) { // 跳转到模拟机的订单详情页
                this.$router.push({
                    name: 'simulationOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 12) { // 跳转到计时卡的订单详情页
                this.$router.push({
                    name: 'timeAppPayOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 13) { // 跳转到微课订单详情页
                this.$router.push({
                    name: 'welfareOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 14) { // 跳转到vip商品订单详情页
                this.$router.push({
                    name: 'vipGoodsOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else {
                this.$router.push({
                    name: 'vipOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            }
        },
        // 转换商品
        goodsSwitch (v) {
            // 防重复点击
            if (this.cGoodsDto.goodsCode === v.goodsCode) {
                this.getSetting()
                this.getPlayAuth()
                return
            }
            Toast.loading({ duration: 0, overlay: true, message: '加载中...' })
            let postData = {
                goodsCode: v.goodsCode
            }
            this.$api.switchGoods(postData).then(res => {
                setTimeout(() => {
                    Toast.clear()
                }, 500)
                if (res.status) {
                    this.goodsCode = v.goodsCode
                    this.cGoodsDto = res.result.settingDto
                    this.getSetting()
                    this.getPlayAuth()
                    this.pageDto.noneOpendSonSelectedDto = res.result
                    // 修改日期
                    setTimeout(() => {
                        if (document.querySelector('#buy-time')) {
                            // 修改日期
                            document.querySelector('#buy-time').innerHTML = this.cGoodsDto.effectiveDays
                        }
                    }, 200)
                } else {
                    Toast(res.message)
                }
            })
        },
        // 获取页面数据
        getPageData () {
            let postData = {
                cityCode: this.cityCode,
                entryType: '2',
                subject: this.subject,
                goodsCode: this.goodsCode
            }

            postData.examPlaceBatchId = this.$route.query.examPlaceBatchId ? this.$route.query.examPlaceBatchId : sessionStorage.getItem('vipGoodsExamPlaceBatchId') || ''

            // 判断是否有指定商品
            let apiName = this.goodsCode ? this.$api.fixedGoodsEntry : this.$api.unfixedGoodsEntry
            Toast.loading({ duration: 0, overlay: true, message: '加载中...' })
            this.loading = true
            apiName(postData).then(res => {
                this.$nextTick(() => {
                    window.scrollTo(0, 0)
                    window.scrollTo(0, 1)
                })
                Toast.clear()
                this.loading = false
                if (res.message.indexOf('用户已开通该考场') > -1) {
                    this.$jsBridge.callBackHandler('returnLastPage')
                    return
                }

                if (res.status) {
                    if (res.result.generalVipDto || res.result.anyoneVipDto) {
                        this.$router.replace({ name: 'vipGoodsOpened', query: this.$route.query })
                        return
                    }
                    this.pageDto = res.result.noneOpendDto

                    // 默认选择第一个商品
                    this.cGoodsDto = this.pageDto.noneOpendSonSelectedDto.settingDto

                    this.goodsCode = this.cGoodsDto.goodsCode

                    setTimeout(() => {
                        if (document.querySelector('#buy-time')) {
                            // 修改日期
                            document.querySelector('#buy-time').innerHTML = this.cGoodsDto.effectiveDays
                        }
                    }, 200)

                    // 搭配商品选项

                    if (this.pageDto.noneOpendSonHookDtoList) {
                        this.switchGoods = [this.pageDto.noneOpendSonSelectedDto.settingDto, ...this.pageDto.noneOpendSonHookDtoList]
                    }

                    // 兼容自动开通
                    if (this.autoOpen) {
                        localStorage.removeItem('t-c-goodsCode')
                        this.submit(this.$route.query.examPlaceBatchId)
                        return
                    }

                    // 获取缓存商品code
                    if (localStorage.getItem('t-c-goodsCode')) {
                        this.goodsSwitch({ goodsCode: localStorage.getItem('t-c-goodsCode') })
                        localStorage.removeItem('t-c-goodsCode')
                    } else {
                        this.getPlayAuth()
                        this.getSetting()
                    }

                    this.checkCarType()
                } else {
                    if (res.message.indexOf('请求错误，请联系客服') > -1) {
                        this.goBack()
                        return
                    }
                    Toast(res.message)
                }
            })
        },
        // 支付回调
        payCallback (v) {
            // 开通成功
            if (String(v) === '1') {
                this.$jsBridge.callBackHandler('openSuccess', { goodsCode: this.goodsCode })
            }
        },
        // 检查车型
        checkCarType () {
            const carTypeName = this.$store.getters.carTypeName

            if (Number(this.carType) !== 1) {
                this.messageDialog = {
                    visible: true,
                    rightBtnName: '切换题库',
                    leftBtnName: '我知道了',
                    leftBtnMethod: () => {
                        this.messageDialog.visible = false
                    },
                    rightBtnMethod: () => {
                        this.messageDialog.visible = false

                        this.$jsBridge.callBackHandler('pushQuestionBankSettingPage')
                    },
                    title: '温馨提示',
                    content: `该服务现仅适用于小车学员，您当前车型-${carTypeName[this.carType]}，是否需切换回小车题库？`
                }
            }
        },
        // 刷新数据
        refreshCallBack () {
            // 重新获取app用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            // 重新获取app token
            let ctlToken = this.$jsBridge.callBackHandler('passTokenData')

            if (ctlToken) {
                localStorage.setItem('ctl-token', JSON.parse(ctlToken).token)
            }

            // 重新设置车型
            this.carType = Number(this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || 1))

            this.disabled = this.carType !== 1

            // 重新设置城市code
            this.cityCode = this.$route.query.cityCode || this.$jsBridge.callBackHandler('passRegionCodeData')

            this.getPageData()

            // 检查车型
            this.checkCarType()

            this.key++
        },
        // 在线客服
        pushCusService () {
            this.$jsBridge.callBackHandler('pushCusService')
        },
        // 跳转支付教程
        goTutorial () {
            localStorage.setItem('t-c-goodsCode', this.goodsCode)

            this.$router.push({ name: 'vipGoodsTutorial' })
        },
        // 打开分享面板
        openSharePanel () {
            // 标题
            let title = this.cGoodsDto.goodsName
            // 内容
            let content = this.cGoodsDto.goodsDesc || ' '
            // 分享链接
            let shareUrl = location.origin.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn')
            // 拼接路径
            shareUrl += location.pathname
            // 拼接参数
            shareUrl += `?id=${this.goodsCode}&shareType=h5&appType=${this.appType}&cityCode=${this.cityCode}&examPlaceBatchId=${this.examPlaceBatchId}&subject=${this.subject}`
            // 图片链接
            let imageUrl = location.origin + require(`@/assets/vipGoods/${this.goodsCode}/${this.codeList[this.goodsCode].top}`)
            // 页面编码
            let pageCode = this.codeList[this.goodsCode].shareCode

            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 跳转app
        linkApp () {
            // 判断设备
            if (this.IOS) {
                // qq浏览器特殊处理
                if (String(navigator.userAgent.toLowerCase().match(/QQ/i)) === 'qq') {
                    let body = document.querySelectorAll('body')[0]
                    let div = document.createElement('div')
                    let img = document.createElement('img')
                    div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                    div.onclick = () => {
                        body.removeChild(div)
                    }
                    img.src = require('@/assets/public/icon_fxts.png')
                    img.style = 'width:100%'
                    div.appendChild(img)
                    body.appendChild(div)
                    return true
                }

                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    : 'https://share.banbanjiadao.com/ui/h5/bb/index'
            } else {
                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
            }
        },
        // 返回
        goBack () {
            if (this.$route.query.back) {
                this.$router.back()
            } else {
                this.$jsBridge.callBackHandler('returnLastPage')
            }
        },
        handleScroll () {
            if (document.querySelectorAll('.footer-item-menu')[0]) {
                document.querySelectorAll('.footer-item-menu')[0].style.display = window.scrollY > 700 ? 'flex' : 'none'
            }
        },
        // 打开会员开通协议页面
        handleOpenMember () {
            this.$jsBridge.callBackHandler('pushSecondaryPage', {
                secondaryUrl: `${window.location.origin}/ui/h5/agreement/memberPartyInfo`
            })
        }
    },
    created () {
        let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

        this.goodsCode = this.$route.query.id
        this.subject = this.$route.query.subject
        if (String(this.subject) === '5') {
            this.subject = '4'
        }
        if (String(this.subject) === '0') {
            this.subject = '1'
        }
        this.shareType = this.$route.query.shareType

        this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || this.$route.query.cityCode

        this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)

        this.version = this.$jsBridge.callBackHandler('getAppVersion')

        // 暴露支付回调方法
        this.$jsBridge.registerHandler('payCallback', this.payCallback)

        this.carType = Number(this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || 1))

        this.userInfo = userInfo ? JSON.parse(userInfo) : {}

        this.disabled = this.carType !== 1

        // 设置自动开通
        this.autoOpen = this.$route.query.isOpen

        // 设置H5标记
        this.H5 = this.$route.query.shareType === 'h5'

        this.$jsBridge.registerHandler('refreshCallBack', this.refreshCallBack)
    },
    mounted () {
        this.getPageData()
        window.addEventListener('scroll', this.handleScroll)

        setTimeout(() => {
            this.warnTipsShow = false
        }, 3000)
    },
    deactivated () {
        this.player.dispose && this.player.dispose()
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>
<style scoped lang="scss">

.footer{
    position: sticky;
    bottom: -1px;
    z-index: 9;
    padding: 5px 10px;
    background: #ffffff;
    .footer-item-menu{
        margin: 5px 0 10px 0;
        display: none;
        justify-content: center;
        .footer-item-menu-content{
            position: relative;
            box-sizing: border-box;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 88px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #C0C1C4;
            text-align: center;
            line-height: 1;
            .title{
                font-size: 15px;
                line-height: 18px;
                font-weight: 600;
                color: #6A220D;
            }
            .price{
                margin: 5px 0 0 0;
                font-size: 15px;
                color: #6A220D;
            }
            .right-top-icon{
                position: absolute;
                background: #FEE068;
                border-radius: 2px 5px 2px 5px;
                font-size: 12px;
                font-weight: 600;
                color: #7F2500;
                padding: 3px 4px;
                transform-origin: 0 0;
                top: -6px;
                z-index: 99;
                right: -1px;
            }
        }
        .footer-item-menu-content+.footer-item-menu-content{
            margin: 0 0 0 5px;
        }
        .footer-item-menu-content.active{
            background: #212528;
            .title,.price{
                color: #FFFFFF;
            }
            &::after{
                content: ' ';
                position: absolute;
                right: -1px;
                bottom: -1px;
                width: 40px;
                height: 18px;
                background: url("~@/assets/vipGoods/yx2.png") no-repeat 100%/100%;
            }
            .right-top-icon{
                color: #FFFFFF;
                background: #FF5825;
            }
        }
    }
    .submit{
        position: relative;
        width: 355px;
        height: 60px;
        background: url("~@/assets/vipGoods/ljkt.gif") no-repeat 100%/100%;
        .price{
            margin: 0 0 0 20px;
            position: absolute;
            transform: translateY(-50%);
            top: 50%;
        }
        .price .t1{
            font-size: 24px;
            font-weight: 600;
            color: #FFFFFF;
        }
        .price .unit {
            color: #fff;
            font-size: 15px;
        }
        .price .t2{
            font-size: 15px;
            color: rgba(255, 255, 255, 0.6);
            margin: 0 0 0 5px;
            text-decoration: line-through;
        }
    }
    .submit.disabled{
        background: url("~@/assets/vipGoods/icon_dban_zh.png") no-repeat 100%/100%;
    }
}
.mamber-tips {
    display: flex;
    align-items: center;
    padding: 10px 10px 20px;
    .mamber-info {
        flex: 1;
        color: #666;
        font-size: 13px;
    }
}
.tutorial{
    text-align: right;
    text-decoration: underline;
    font-size: 13px;
    color: #A6431B;
}
.question{
    position: relative;
    width: 355px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 3px solid #FF5825;
    margin: 26px auto 0;
    box-sizing: border-box;
    padding: 40px 15px 20px;
    .title{
        width: 184px;
        position: absolute;
        top: -21px;
        left: 100px;
    }
    .question-title{
        margin: 20px 0 0 0;
        font-size: 15px;
        padding: 0 0 0 25px;
        font-weight: 600;
        color: #864200;
        background: url("~@/assets/vipGoods/wt.png") no-repeat left/16px;
    }
    .question-content{
        word-break: break-all;
        white-space: break-spaces;
        margin: 10px 0 0 26px;
        font-size: 12px;
        color: #000000;
        line-height: 20px;
    }
}
.item-menu{
    display: flex;
    justify-content: center;
    padding: 15px 10px 8px;
    .item-menu-content{
        position: relative;
        box-sizing: border-box;
        flex: 1;
        height: 135px;
        background: #FFFFFF;
        border-radius: 5px;
        border: 3px solid #CCCCCC;
        text-align: center;
        line-height: 1;
        .title{
            display: flex;
            align-items: flex-end;
            justify-content: center;
            height: 48px;
            font-size: 18px;
            font-weight: 600;
            color: #000000;
        }
        .price{
            margin: 7px 0 0 0;
            font-size: 15px;
            font-weight: 600;
            color: #FF5050;
        }
        .price b{
            font-size: 24px;
        }
        .desc{
            margin: 7px 0 0 0;
            font-size: 13px;
            color: #A6431B;
        }
        .right-top-icon{
            position: absolute;
            padding: 3px 8px;
            background: #FEE068;
            border-radius: 2px 5px 2px 5px;
            margin: 0 0 0 5px;
            right: -3px;
            top: -10px;
            font-size: 12px;
            font-weight: 600;
            color: #7F2500;
        }
    }
    .item-menu-content+.item-menu-content{
        margin: 0 0 0 5px;
    }
    .item-menu-content.active{
        background: #FFF0EC;
        border: 3px solid #FF5825;
        &::after{
            content: ' ';
            position: absolute;
            right: -1px;
            bottom: -1px;
            width: 40px;
            height: 18px;
            background: url("~@/assets/vipGoods/yx.png") no-repeat 100%/100%;
        }
        .right-top-icon{
            color: #FFFFFF;
            background: #FF5825;
        }
    }
}
.bg{
    width: 100%;
}

.wrap{
    background: #FFF6E4;
}
.header{
    position: sticky;
    top: 0;
    z-index: 9;
    background: #ffffff;
    display: flex;
    align-items: center;
    padding: 13px 10px;
    .header-left,.header-right{
        display: flex;
        align-items: center;
        width: 100px;
        img{
            width: 24px;
        }
    }
    .header-right{
        justify-content: flex-end;
        img+img{
            margin: 0 0 0 13px;
        }
    }
    .header-main{
        white-space: nowrap;
        text-align: center;
        flex: 1;
        font-size: 18px;
        font-weight: 600;
        color: #333333;
    }
}
.video{
  position: absolute;
  left: 50%;
  top: 50px;
  transform: translate(-50%);
}
.play-icon{
  position: absolute;
  left: 50%;
  top: 135px;
    font-size: 0;
  transform: translate(-50%);
  img{
    width: 51px;
  }
}
.tips-effect-wrap{
    position: fixed;
    top: 340px;
    left: 103px;
    z-index: 99;
    .tips-effect{
        animation: tipsEffectWrap 3s;
        animation-fill-mode:forwards;
        position: relative;
        background: #dc2a35;
        border-radius: 12px;
        overflow: hidden;
        width: 170px;
        height: 190px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .content{
            font-weight: 600;
            font-size: 24px;
            color: #FEE068;
            text-align: left;
        }
        .right-price{
            padding: 6px 15px;
            background: #f8e066;
            position: absolute;
            right: 0;
            top: 0;
            font-weight: 600;
            font-size: 18px;
            color: #7F2500;
            text-align: left;
            border-radius: 0 0 0 12px;
        }
    }
}
@keyframes tipsEffectWrap
{
    0%   {
        transform: translate(0,600px) scale(1);
        opacity: 1;
    }
    50%  {
        transform: translate(0,0) scale(1);
        opacity: 1;
    }
    100%  {
        transform: translate(0,0) scale(0);
        opacity: 0;
        display: none;
    }
}

</style>
